import React, { useState, useEffect } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  Button
} from "reactstrap";
import { useConversation } from "@11labs/react";
import { postDataAPI } from "../../helpers/phpbackend_helper";
import { useSelector } from "react-redux";

const PracticeVoiceModal = ({ isOpen, toggle, card }) => {
  const conversation = useConversation();

  const [isStarting, setIsStarting] = useState(false);
  const [conversationStartTime, setConversationStartTime] = useState(null);

  useEffect(() => {
    return () => {
        if (conversation.status !== "idle") {
            conversation.endSession().catch(() => {});
        }
        };
    }, []);

  if (!card) return null;

    
    

  const dishName = card.item_name;
  const flashcardContent = card.format_coching_script;
  const firstName = "User";

  const buildPrompt = () => `
    You are Erin, a Food & Beverage Server Performance AI Coach.
    Train the server on the dish "${dishName}".

    Key talking points:
    ${flashcardContent}

    Ask natural customer-style questions and guide the server.
    `;

    const buildFirstMessage = () =>
        `Hi ${firstName}, today we’ll practice selling ${dishName}. Ready to begin?`;

    const startPractice = async () => {
        try {
        setIsStarting(true);

        if (conversation.status !== "idle") {
            await conversation.endSession().catch(() => {});
        }

        await navigator.mediaDevices.getUserMedia({ audio: true });
        
        let signedUrl = "";
        postDataAPI({
            serviceName: "server_data",
            op: "agent_get_signed_url"
        }).then((res) => {
            if (res.status === "ok") {
                signedUrl = res.data?.signedUrl || "";
                if (!signedUrl) throw new Error("No signed URL");
                conversation.startSession({
                    signedUrl,
                    overrides: {
                    agent: {
                        prompt: { prompt: buildPrompt() },
                        firstMessage: buildFirstMessage()
                    }
                    }
                });
                setConversationStartTime(Date.now());
            } else {
            alert(res.message || "Failed to load agent!");
            }
        });        
        } catch (err) {
            console.error(err);
            alert("Could not start practice");
        } finally {
            setIsStarting(false);
        }
    };

    const endPractice = async () => {
        await conversation.endSession().catch(() => {});
        setConversationStartTime(null);
        //toggle();
    };

    

    const isActive = conversation.status === "connected";

    return (
        <Modal isOpen={isOpen} toggle={toggle} centered size="md">
        <ModalHeader toggle={toggle}>
            🎙 Practice Your Sales Pitch
            <div className="text-muted small">
            Practice selling this dish with an AI customer
            </div>
        </ModalHeader>

        <ModalBody className="text-center">
            <div className="border rounded p-3 mb-4">
            <small className="text-muted">Training on:</small>
            <h5 className="fw-bold mb-0">{dishName}</h5>
            </div>

            {!isActive ? (
            <>
                <i
                    className={`ri-mic-fill fs-1`}
                />
                <div className="mb-3 text-muted">
                Click start to begin practice
                </div>

                <Button
                color="primary"
                className="w-100"
                onClick={startPractice}
                disabled={isStarting}
                >
                🎤 {isStarting ? "Starting..." : "Start Practice"}
                </Button>
            </>
            ) : (
            <>
                <i
                    className={`ri-mic-fill fs-1`}
                />
                <div className="my-3 text-danger fw-medium">
                🔴 AI is speaking...
                </div>

                <Button
                color="danger"
                className="w-100"
                onClick={endPractice}
                >
                ⏹ End Practice
                </Button>
            </>
            )}

            <div className="bg-light rounded p-3 mt-4 text-start">
            <small className="fw-medium">Tips for practice:</small>
            <ul className="mb-0 small text-muted">
                <li>Speak clearly about dish features</li>
                <li>Highlight unique selling points</li>
                <li>Answer customer questions naturally</li>
                <li>Use the flashcard content as a guide</li>
            </ul>
            </div>
        </ModalBody>
        </Modal>
    );
};

export default PracticeVoiceModal;
